import React, { useState } from 'react'
import { Col, Row } from 'reactstrap';

import ContactCategoryList from './_list';
import ContactCategoryForm from './_form';
import { ButtonNew } from "../../../components/buttons/buttonsActions";

const ContactCategory = props => {
    const [viewMode, setViewMode] = useState("LIST")
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const setForm = (editModeP, data, viewModeP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setItem(data);
        setViewMode(viewModeP ? viewModeP : "LIST")
    }

    return (<>
        {
            viewMode === "LIST"  ? <>
                <Row>
                    <Col md="12">
                        <div className="d-flex align-items-center">
                            <div className="ml-auto paddingAdd">
                                <ButtonNew onClick={() => setForm(null, null, "FORM")}/>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ContactCategoryList
                            setForm={ setForm }
                            app={props.app}
                        />
                    </Col>
                </Row>
            </> : <Row>
                <Col>
                    <ContactCategoryForm
                        setForm={ setForm }
                        updateItem={ setItem }
                        item={ item }
                        editMode={ editMode }
                        app={props.app}
                    />
                </Col>
            </Row>

        }
    </>)
}

export default ContactCategory
